import { Component } from '@theme/component';

/** Reuse the native picker response so ingredients follow the selected size. */
class KunnieProductAccordions extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    document.addEventListener('shopify:product:select', async (event) => {
      if (String(event.product?.id).split('/').pop() !== this.dataset.product) return;
      try {
        const result = await event.promise;
        if (!this.isConnected) return;
        const source = result?.detail?.html?.querySelector(`kunnie-product-accordions[data-product="${this.dataset.product}"]`);
        if (!source) return;
        const fresh = source.querySelector('[data-ingredients]');
        const current = this.querySelector('[data-ingredients]');
        if (fresh && current) {
          current.querySelector('.kunnie-accordions__content').replaceChildren(...fresh.querySelector('.kunnie-accordions__content').childNodes);
        } else if (current) {
          current.remove();
        } else if (fresh) {
          const usage = this.querySelector('.kunnie-accordions__row:nth-child(2)');
          if (usage) usage.after(fresh); else this.append(fresh);
        }
      } catch { /* The native picker handles interrupted or failed selections. */ }
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get('kunnie-product-accordions')) customElements.define('kunnie-product-accordions', KunnieProductAccordions);
